<template>
  <div class="card-condition connection-type" :class="{ noteq: predicate === 'NOT_EQUALS' }">
    <ui-icon @click="emit('close')" icon="fas fa-times" size="12" class="card-condition__close" />
    <ui-radio-group style-type="inline" class="mb-16" v-model="predicate" :label="t('Day of week')">
      <div class="d-flex align-baseline ml-16">
        <ui-radio value="EQUALS" :label="t('Equals')" />
        <ui-radio class="ml-16" value="NOT_EQUALS" :label="t('Not equal')" />
      </div>
    </ui-radio-group>
    <div class="type-group">
      <ui-checkbox
        v-for="(item, index) in days"
        :key="index"
        :true-value="item"
        v-model="selected[index]"
        class="mr-16"
        :label="item"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useFlowDayOfWeekCondition } from './useFlowDayOfWeekCondition';

const props = defineProps<{
  conditions: Record<string, { predicate: string; values: string[] }>;
}>();

const emit = defineEmits<{
  close: [];
}>();

const { t, days, predicate, selected } = useFlowDayOfWeekCondition(props.conditions);
</script>

<style lang="scss" scoped>
.type-group {
  display: flex;
  flex-wrap: wrap;
}
</style>
